import i18n from '../../../../locales/i18n';
import { SelectedValueType } from './parameterSelector';

export type ValidatorType = (
  parameter: ParameterValidatorData,
  data: SelectedValueType | undefined
) => string | undefined;

export type ParameterValidatorData = {
  type: string;
  range: (string | number)[];
  parameter: string;
};

const currentLanguage = i18n.language;

const validateBool = (parameter: ParameterValidatorData, data: SelectedValueType | undefined): string | undefined => {
  return typeof data === 'boolean' ? undefined : 'Invalid Input';
};

const validateNumber = (parameter: ParameterValidatorData, data: SelectedValueType | undefined): string | undefined => {
  if (data === undefined || data === null || isNaN(Number(data))) {
    if (currentLanguage == 'de') return 'Keine Zahl'
    else return 'Not a number';
  } else if (parameter.range[0] !== undefined && parameter.range[0] !== null && data < parameter.range[0]) {
    if (currentLanguage == 'de') return `Muss größer oder gleich ${parameter.range[0]} sein`;
    else return `Needs to be greater or equal to ${parameter.range[0]}`;
  } else if (parameter.range[1] !== undefined && parameter.range[1] !== null && data > parameter.range[1]) {
    if (currentLanguage == 'de') return `Muss kleiner oder gleich ${parameter.range[1]} sein`;
    else return `Needs to be less or equal to ${parameter.range[1]}`;
  }
  return undefined;
};

const validateInt = (parameter: ParameterValidatorData, data: SelectedValueType | undefined): string | undefined => {
  console.log(parameter)
  let error = validateNumber(parameter, data);
  if (error === undefined && !Number.isInteger(data)) {
    if (currentLanguage == 'de') error = 'Keine ganze Zahl'
    else error = 'Not an integer';
  }
  return error;
};

const validateEnum = (parameter: ParameterValidatorData, data: SelectedValueType | undefined): string | undefined => {
  return (typeof data === 'number' || typeof data === 'string') && parameter.range.includes(data)
    ? undefined
    : 'Invalid Input';
};

const validatorMap: Record<string, ValidatorType> = {
  bool: validateBool,
  double: validateNumber,
  enum: validateEnum,
  int: validateInt,
};

const validate = (parameter: ParameterValidatorData, data: SelectedValueType | undefined): boolean =>
  validatorMap[parameter.type](parameter, data) === undefined;

const validateAll = (
  parameters: ParameterValidatorData[],
  data: Record<string, SelectedValueType | undefined>
): boolean => {
  return parameters.every(parameter => /*data[parameter.parameter] &&*/ validate(parameter, data[parameter.parameter]));
}

export const ParameterValidatorService = {
  validate,
  validateAll,
  validateBool,
  validateNumber,
  validateInt,
  validateEnum,
};
